var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2891_50065)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.61629 19.9106H4.78817V1.66992H15.2108V19.9106H16.3827V0.498047H3.61629V19.9106Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1701 19.3247H2.82917V20.4965H17.1701V19.3247Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.13205 19.9165V16.2889C7.13205 14.7053 8.41584 13.4215 9.99951 13.4215C11.5831 13.4215 12.8669 14.7053 12.8669 16.2889V19.9165H14.0388V16.2889C14.0388 14.0581 12.2303 12.2496 9.99951 12.2496C7.76864 12.2496 5.96017 14.0581 5.96017 16.2889V19.9165H7.13205Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18675 16.2889C8.18675 17.2901 8.99834 18.1017 9.99949 18.1017C11.0006 18.1017 11.8122 17.2901 11.8122 16.2889C11.8122 15.2878 11.0006 14.4762 9.99949 14.4762C8.99834 14.4762 8.18675 15.2878 8.18675 16.2889ZM9.99949 16.9298C9.64555 16.9298 9.35863 16.6429 9.35863 16.2889C9.35863 15.935 9.64555 15.6481 9.99949 15.6481C10.3534 15.6481 10.6403 15.935 10.6403 16.2889C10.6403 16.6429 10.3534 16.9298 9.99949 16.9298Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.95042 6.96627C5.95042 9.2025 7.76326 11.0153 9.99948 11.0153C12.2357 11.0153 14.0485 9.2025 14.0485 6.96627C14.0485 4.73005 12.2357 2.91721 9.99948 2.91721C7.76326 2.91721 5.95042 4.73005 5.95042 6.96627ZM9.99948 9.84346C8.41047 9.84346 7.1223 8.55529 7.1223 6.96627C7.1223 5.37726 8.41047 4.08909 9.99948 4.08909C11.5885 4.08909 12.8767 5.37726 12.8767 6.96627C12.8767 8.55529 11.5885 9.84346 9.99948 9.84346Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26362 6.96628C8.26362 7.92493 9.04077 8.70217 9.99948 8.70217C10.9582 8.70217 11.7354 7.92495 11.7354 6.96628C11.7354 6.00761 10.9582 5.23038 9.99948 5.23038C9.04077 5.23038 8.26362 6.00762 8.26362 6.96628ZM9.99948 7.5303C9.68803 7.5303 9.43549 7.27778 9.43549 6.96628C9.43549 6.65478 9.68803 6.40225 9.99948 6.40225C10.311 6.40225 10.5635 6.65479 10.5635 6.96628C10.5635 7.27776 10.311 7.5303 9.99948 7.5303Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9995 9.91137H18.2838V11.0832H19.9995V9.91137Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.419 7.26767L17.2058 8.48087L18.0345 9.30951L19.2477 8.09631L18.419 7.26767Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2477 12.8983L18.0345 11.6851L17.2058 12.5137L18.419 13.7269L19.2477 12.8983Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.000488281 11.0832H1.71521V9.91137H-0.000488281V11.0832Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.751308 8.09631L1.96451 9.30951L2.79315 8.48087L1.57995 7.26767L0.751308 8.09631Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.57995 13.7269L2.79315 12.5137L1.96451 11.6851L0.751308 12.8983L1.57995 13.7269Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2891_50065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg23);
export default __webpack_public_path__ + "static/media/23.d32fcf233b4e24e6b93a5675e2919ffb.svg";
export { ForwardRef as ReactComponent };